import React from "react";
import { ArrowRight } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const handleLogin = () => {
    const redirectUrl = window.location.origin + "/board";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

const HERO_IMAGE =
    "https://images.unsplash.com/photo-1486551937199-baf066858de7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGxpbmVzfGVufDB8fHx8MTc3OTEwOTk1Nnww&ixlib=rb-4.1.0&q=85";

export default function Login() {
    return (
        <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2" data-testid="login-page">
            {/* Left: hero */}
            <div className="relative hidden lg:block bg-black">
                <img
                    src={HERO_IMAGE}
                    alt="Abstract geometric lines"
                    className="absolute inset-0 w-full h-full object-cover opacity-90"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/60" />
                <div className="relative h-full flex flex-col justify-between p-10 text-white">
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-white" />
                        <span className="label-eyebrow">PIPELINE / VENTAS</span>
                    </div>
                    <div>
                        <h1 className="font-display text-5xl xl:text-6xl leading-[1.05] max-w-md">
                            Tu pipeline.
                            <br />
                            Sin ruido.
                        </h1>
                        <p className="mt-6 max-w-sm text-sm text-white/80">
                            Una vista clara de cada oportunidad. Sube clientes, mueve estados,
                            cierra negocios.
                        </p>
                    </div>
                </div>
            </div>

            {/* Right: form */}
            <div className="flex items-center justify-center p-8 lg:p-16 bg-white">
                <div className="w-full max-w-sm">
                    <div className="flex items-center gap-2 mb-12">
                        <span className="label-eyebrow text-neutral-500">
                            ACCESO · INTERNO
                        </span>
                    </div>
                    <h2 className="font-display text-4xl lg:text-5xl leading-tight">
                        Bienvenido
                        <br />
                        de vuelta.
                    </h2>
                    <p className="mt-4 text-sm text-neutral-600">
                        Inicia sesión con tu cuenta de Google para acceder al panel.
                    </p>

                    <div className="mt-10 space-y-4">
                        <button
                            data-testid="google-login-button"
                            onClick={handleLogin}
                            className="w-full bg-[#0A0A0A] text-white px-6 py-4 border border-[#0A0A0A] hover:bg-white hover:text-[#0A0A0A] transition-all duration-200 flex items-center justify-between group"
                        >
                            <span className="flex items-center gap-3">
                                <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden>
                                    <path
                                        fill="currentColor"
                                        d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
                                    />
                                    <path
                                        fill="currentColor"
                                        d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.836.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
                                    />
                                    <path
                                        fill="currentColor"
                                        d="M3.964 10.707A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.707V4.96H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.04l3.007-2.333z"
                                    />
                                    <path
                                        fill="currentColor"
                                        d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.96L3.964 7.293C4.672 5.166 6.656 3.58 9 3.58z"
                                    />
                                </svg>
                                Continuar con Google
                            </span>
                            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                        </button>

                        <p className="text-xs text-neutral-500 mt-8 leading-relaxed">
                            Solo personal autorizado. El primer usuario en acceder será
                            administrador del sistema.
                        </p>
                    </div>

                    <div className="mt-16 pt-6 border-t border-black/10 flex justify-between text-xs text-neutral-500">
                        <span>v1.0</span>
                        <span>PIPELINE CRM</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
